import Header from './components/Header';
import HeroSection from './components/HeroSection';
import { TopicsSection, IndexSection, ContactSection } from './components/SectionsGroup1';
import { CardsSection, UpdatesSection, CommentsSection } from './components/SectionsGroup2';
import { FaqSection, RankingSection, AboutSection } from './components/SectionsGroup3';
import { CarouselSection, AppSection, MediaSection, FeaturesSection } from './components/SectionsGroup4';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <IndexSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <CommentsSection />
        <FaqSection />
        <RankingSection />
        <AboutSection />
        <CarouselSection />
        <AppSection />
        <MediaSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}